module.exports = __webpack_public_path__ + "img/一体柜.54864566.png";